export const OVERVIEW_VIEW_NAMESPACE = 'overview-view';
